import React,{createContext,useContext,} from 'react'
import {createUserWithEmailAndPassword} from 'firebase/auth'
import {signInWithEmailAndPassword,onAuthStateChanged} from 'firebase/auth'

import { auths } from '../utils/firebaseOtro'
import { errorsFirebase } from '../utils/Validations'
import db from '../utils/firebase'

export const authContext = createContext()

export const useAuth = ()=>{
    const context =useContext(authContext)
    return context
}

export function AuthProvider({children}){

    const [user,setUser] = React.useState(null)
    const [dataUser,setDataUser] = React.useState(null)
    const [showModal,setShowModal] = React.useState(false)
    const [titleModal,setTitleModal] = React.useState("")
    const [contentModal,setContentModal] = React.useState()

    

    const [dataSeries,setDataSeries] = React.useState([])
    const [peliculasRecientementes,setPeliculasRecientementes] = React.useState([])
    const [misFavoritas,setMisFavoritas]=React.useState([])
    const [misFavoritasPeliculas,setMisFavoritasPeliculas]=React.useState([])
    const [admin,setAdmin] = React.useState(false)

    const limite=20
    const [listaSeleccionada,setListaSeleccionada]= React.useState({value:"sinselect"})
    const [peliculas,setPeliculas]=React.useState()
    const [startPeliculas,setStartPeliculas] = React.useState()




    const signUp = async (email,password)=>{

        const result ={statusResponse:true,error:null}

       await createUserWithEmailAndPassword(auths,email,password).catch((err)=>{
            result.error=err.code
            result.statusResponse=false
       })
       return result
    }

    const login = async (email,password) =>{

        const result ={statusResponse:true,error:null}

       await signInWithEmailAndPassword(auths,email,password).then(()=>{
    
        }).catch((err)=>{
           result.error=err.code
           result.statusResponse=false
              
        })

        return result

    }
    const getPeliculasCategoria = async  (type) =>{

        const result ={statusResponse:true,error:null,peliculas:[]}



        
            
           await  db.collection("peliculas").where("type","==",type).get().then((response)=>{
            if(response.docs.length > 0){
                const res =  response.docs.map((doc)=>{
                    const data = doc.data()
                    return{
                        ...data
                    }
                })

                result.peliculas =res
            }else{
            }
        })
        
    
    
    return result

        

    }


    
    
    React.useEffect(()=>{
        
        onAuthStateChanged(auths,(currentUser)=>{
            setUser(currentUser)
            
            
        })
        
    },[])

    const verificarAdmin =async ()=>{

       await db.collection("admins").doc(user.uid).get().then((response)=>{
            setAdmin(response.exists)
        })
    }


    
    React.useEffect(() =>{
        if(user){

            db.collection("peliculas").orderBy("createAt","desc").limit(20).get().then((response) =>{

    
                if(response.docs.length>0){

                    const result = response.docs.map((doc)=>{
                        const data = doc.data()
                        data.id=doc.id
    
                        return{
                            ...data
    
                        }
                    })
                    setPeliculasRecientementes(result)
                }
            
               
            }).finally(()=>{
                db.collection("series").orderBy("createAt","desc").limit(10).get().then((response) =>{
            
             
                    if(response.docs.length>0){
                         const result =  response.docs.map((doc)=>{
                                 const data = doc.data()
                                 data.id=doc.id
             
                                 return{
                                     ...data
             
                                 }
                             })
                        
     
                         setDataSeries(result)
                            }
                        }).finally(()=>{
                            verificarAdmin()

                        })
                
            })
        }
    },[user])


    React.useEffect(()=>{
        if(dataSeries?.length>0){

            db.collection("likes").where("email","==",user?.email).where("like","==",true).orderBy("createAt","desc").get().then((res)=>{
                if(res.docs.length>0){
                    const result = res.docs.map((doc)=>{
                        const data = doc.data()
                        return{
                            ...data.dataPeli
                        }
                    })
                    setMisFavoritas(result)
                }
            })
        }

    },[user,dataSeries])

    React.useEffect(()=>{
        if(dataSeries?.length>0){
            
                    if(listaSeleccionada.value === "sinselect"){
            
                        let result = db.collection("peliculas").orderBy("createAt","desc").limit(limite)
                        result.get().then((response)=>{
                
                            setStartPeliculas(response.docs[response.docs.length-1])
                
                            if(response.docs.length > 0){
                
                                const res =  response.docs.map((doc)=>{
                                    const data = doc.data()
                                    return{
                                        ...data
                                    }
                                })
                    
                                setPeliculas(res)
                            }
                        })   
            
                    }else{
            
                        let result = db.collection("peliculas").where("type","==",listaSeleccionada.value).orderBy("createAt","desc").limit(limite)
                        result.get().then((response)=>{
                
                            setStartPeliculas(response.docs[response.docs.length-1])
                
                            if(response.docs.length > 0){
                
                                const res =  response.docs.map((doc)=>{
                                    const data = doc.data()
                                    return{
                                        ...data
                                    }
                                })
                    
                                setPeliculas(res)
                            }
                        })   
                    }

        }

        


    },[listaSeleccionada.value,user,dataSeries])


  

    

   
  

    return(
        <authContext.Provider value={{
                                        signUp,
                                        login,
                                        user,
                                        dataUser,
                                        showModal,
                                        setShowModal,
                                        setTitleModal,
                                        setContentModal,
                                        contentModal,
                                        titleModal,
                                        peliculasRecientementes,
                                        dataSeries,
                                        getPeliculasCategoria,
                                        misFavoritas,
                                        misFavoritasPeliculas,
                                        admin,
                                        setListaSeleccionada,
                                        peliculas,
                                        startPeliculas,
                                        setStartPeliculas,
                                        listaSeleccionada,
                                        setPeliculas

                                        
                                    }} >
            {
                children
            }

        </authContext.Provider>
    )
}